import { ReactNode } from 'react';
import { Permission } from '../../domain/permissions';
import { usePermissions } from './usePermissions';

type HasPermissionProps = {
    permission?: Permission;
    anyPermission?: Permission[];
    allPermissions?: Permission[];
    children: ReactNode;
    fallback?: ReactNode;
}

export const HasPermission = ({ 
    permission, 
    anyPermission, 
    allPermissions, 
    children, 
    fallback = null 
}: HasPermissionProps) => {
    const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions();

    let hasAccess = false;

    if (permission) {
        hasAccess = hasPermission(permission);
    } else if (anyPermission) {
        hasAccess = hasAnyPermission(anyPermission);
    } else if (allPermissions) {
        hasAccess = hasAllPermissions(allPermissions);
    } else {
        // If no permissions specified, default to having access (or you might want the opposite)
        hasAccess = true;
    }

    if (!hasAccess) {
        return <>{fallback}</>;
    }

    return <>{children}</>;
};
